<template>
  <van-popup v-model="surveyPop">
    <div class="survey" >
      <div class="fi1" v-if="!finish">
        <div class="close iconfont icon-close" @click="close"></div>
        <div class="pop-top">
          <!-- <span class="iconfont icon-draft-line"></span> -->
          <img src="@/assets/images/feedback.svg" class="img"/>
          <span class="title">体验小调研</span>
        </div>
        <div class='pop-content'>
          <div class="text">
            <span>Hi,很高兴与您见面~</span>
            <br/>
            <span>您对我们的视频内容满意吗？</span>
          </div>
          <div class="start">
            <van-rate v-model="value" color="#ff6200" size="30px" gutter="10px" @change="changeRate"/>
          </div>
        </div>
      </div>
       <div class="finish" v-else>
        <img src="@/assets/images/ico-home-like.png" class="img"/>
        <div class="text">谢谢您的反馈</div>
      </div>
    </div>
   
  </van-popup>
</template>
<script>
export default {
  components:{},
  props:{visible:Boolean,videoId:[String,Number]},
  data(){
    return{
      surveyPop:false,
      value:0,
      finish:false
    }
  },
  mounted() {
    
  },
  methods: {
    close(){
      this.surveyPop = false
      this.$emit('close')
    },
    changeRate(){
      this.submit()
    },
    submit(){
      this.$api.featureApi.playLog({video_id:this.videoId,video_score:this.value}).then(res=>{
        setTimeout(() => {
          this.finish = true
        },500)
        setTimeout(() => {
          this.close()
        }, 3000);
      })
    },
  },
  watch: {
    visible:{
       handler(newv,oldv){
        if(newv){
          this.surveyPop = true
        }
      },immediate:true,deep:true
    }
  }
}
</script>
<style lang="scss" scoped>
  .survey{
    background: linear-gradient(180deg, #fff5ec 0%, #FFFFFF 60%);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    border-radius: 20px;
    overflow: hidden;
    padding: 0 20px 30px;
    width: 250px;
    position: relative;
    .close{
      position: absolute;
      top: 20px;
      right: 20px;
      font-size: 20px;
      color: #999;
      z-index: 2;
    }
    .pop-top{
      font-size: 16px;
      padding: 15px 0;
      border-bottom: 1px solid #efefef;
      font-weight: bold;
      color: #333;
      display: flex;
      align-items: center;
      .iconfont{
        margin-right: 10px;
      }
      .img{
        width: 20px;
        margin-right: 10px;
      }
    }
    .pop-content{
      padding-top: 20px;
      .text{
        font-size: 14px;
        color: #666;
        // background: #fff;
        // padding: 10px 20px;
        // box-shadow: 0 0 5px rgba(0,0,0,.1);
        // border-radius: 20px;
      }
      .start{
        display: flex;
        align-items: center;
        justify-content: center;
        padding-top: 20px;
      }
    }
   
  }
   .finish{
      display: flex;
      width: 100%;
      padding-top: 40px;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .img{
        width: 46px;
        margin-bottom: 20px;
        animation: popScale 1s ease-in-out ;
      }
      .text{
        font-size: 18px;
        color: #777;
      }
    }
    @keyframes popScale {
      0% {
        transform: scale(0.5);
        opacity: 0;
      }
      25% {
        transform: scale(1.2);
        opacity: 1;
      }
      50% {
        transform: scale(0.8);
      }
      75% {
        transform: scale(1.1);
      }
      100% {
        transform: scale(1);
      }
    }
</style>